export default __webpack_public_path__ + "static/media/map.2b0b5569.svg";